import {
  GridBooleanCell,
  GridRenderCellParams,
} from '@mui/x-data-grid-premium';

export const BooleanCellComponent = (props: GridRenderCellParams) => {
  const { value } = props;

  if (!!value) {
    return <GridBooleanCell {...props} />;
  }

  return null;
};
